export default "__VITE_ASSET__10e00e19__"